import React from "react";
import TextField from '@material-ui/core/TextField'

import RenderError from '../render-error'

import { getSS } from '../../helpers'

interface DirectDebitProps {
  [key: string]: any
}

const DirectDebit: React.FC<DirectDebitProps> = (props: any) => {

  let membership = getSS('membership')

  return (
    <>
      { membership &&
        <div className="row">
          <div className="direct-debit clearfix box">
            <div className="large-12 columns">
              <h2>Your Direct Debit details</h2>
              { membership.selected_membership.value !== 'youngpersons' &&
                <div>
                  <p>I confirm that I am the account holder and I can authorise Direct Debits on this account.</p>
                </div>
              }
              { membership.selected_membership.value === 'youngpersons' &&
                <div>
                  <p>I confirm that:</p>
                  <ul>
                    <li>I am the account holder</li>
                    <li>I can authorise Direct Debits on this account</li>
                    <li>This account is eligible for Direct Debits</li>
                  </ul>
                </div>
              }
              <p>The fee for your annual membership will be collected from your account on the 21st day of the month. The exact timing of your payment will depend on the date you're filling in this form. We'll confirm in writing, within the next two weeks, the date and amount that will be collected.</p>
              <h2>Bank details</h2>
              <fieldset className="row">
                <legend>Your bank details</legend>
                <div className="large-6 columns">
                  <div className="input-container">
                    <TextField
                      type="text"
                      variant="outlined"
                      id="m-account-holder"
                      name="bank_account_account_name"
                      label="Name of account holder"
                      autoComplete="cc-name"
                      inputProps={{
                        "aria-describedby": "m-account-holder_error"
                      }}
                      error={props.errors.bank_account_account_name ? true : false}
                      value={props.values.bank_account_account_name}
                      onChange={props.handleChange} />
                    <RenderError name="bank_account_account_name" id="m-account-holder_error" {...props} />
                  </div>
                </div>
                <div className="large-6 columns clear">
                  <div className="input-container">
                    <TextField
                      type="tel"
                      variant="outlined"
                      id="m-account-number"
                      name="bank_account_account_number"
                      label="Bank/building society acct number"
                      autoComplete="cc-number"
                      inputProps={{
                        "aria-describedby": "m-account-number_error"
                      }}
                      error={props.errors.bank_account_account_number ? true : false}
                      value={props.values.bank_account_account_number}
                      onChange={(e) => {
                        props.handleChange(e);
                        props.setInvalidBankDetailsMessage('')
                      }} />
                    <RenderError name="bank_account_account_number" id="m-account-number_error" {...props} />
                  </div>
                </div>
                <div className="large-6 columns left">
                  <div className="input-container">
                    <TextField
                      type="tel"
                      variant="outlined"
                      id="m-sort-code"
                      name="bank_account_sort_code"
                      label="Branch sort code"
                      inputProps={{
                        "aria-describedby": "m-sort-code_error"
                      }}
                      error={props.errors.bank_account_sort_code ? true : false}
                      value={props.values.bank_account_sort_code}
                      onChange={(e) => {
                        props.handleChange(e);
                        props.setInvalidBankDetailsMessage('')
                      }} />
                    <RenderError name="bank_account_sort_code" id="m-sort-code_error" {...props} />
                  </div>
                </div>
                { props.invalidBankDetailsMessage &&
                  <div className="large-12 columns">
                    <div className="input-container">
                      <span className="error">{props.invalidBankDetailsMessage}</span>
                    </div>
                  </div>
                }
              </fieldset>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default DirectDebit;